/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useContext } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/actions";
import {
  AEInput,
  Card,
  CardBody,
} from "../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../_metronic/layout";
import { CONTEXT } from "../../helpers/ModuleHelpers";
import {
  toAbsoluteApiUrl,
  toAbsoluteUrl,
} from "../../../../../_metronic/_helpers";
import { AESVG } from "../../../../../_emywork/components/svg";
import { AEButton } from "../../../../../_emywork/components/buttons";
import { AEDuration } from "../../../../../_emywork/components/moment";
import moment from "moment";
import { AEQRCode } from "../../../../../_emywork/components/AEQRCode";
import { AEShareButtons } from "../../../../../_emywork/components/AEShareButtons";
import { AEReport } from "../../../../../_emywork/components/AEReport";
import { AERole } from "../../../../../_emywork/components/AERole";
import { useIntl } from "react-intl";
import { actionTypes } from "../../_redux/slice";
import { AEMetadata } from "../../../../../_emywork/AEPagination";
import {
  API_UPLOAD_PATH,
  localField,
} from "../../../../../_emywork/helpers/UIHelper";
import { useFormik } from "formik";
import {
  HTTP_CREATED,
  HTTP_NOT_FOUND,
  HTTP_PERMISSION_DENIED,
  HTTP_UPDATED,
} from "../../../../../_emywork/helpers/AxiosHelpers";
import * as ReviewActions from "../../_redux/Reviews/actions";
import { roles } from "../../../../../index";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { EmyProductStatus } from "../../componants/Status";
import { getStatusesKeys, isApproved, EMY_PRODUCT_STATUSES } from "../../helpers/StatusHelpers";
import { ROUTES } from "../../helpers/RoutingHelpers";
import { AERating } from "../../../../../_emywork/components/rating";
import { AESlider } from "../../../../../_emywork/components/AESlider";
import { AEFeed } from "../../../../../_emywork/components/AEFeed";
import { AERater } from "../../../../../_metronic/_partials/controls/forms/AERater";
import { AESpinner } from "../../../../../_emywork/spinner/AESpinner";
import { AEPhone, AEUrl } from "../../../../../_emywork/components/AELink";
import { EntityCard as UserEntityCard } from "../../../Users/componants/EntityCard";
import Embed from "react-embed";
import EditableFeedWrapper from "../../../../../_emywork/components/feeds/EditableFeedWrapper";

export function Details({
  history,
  match: {
    params: { slug },
  },
}) {
  const forceHttps = (link) => {
    return link.replace("http://", "https://");
  };
  const { formatMessage } = useIntl();
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const { authUser } = useSelector(
    ({ auth }) => ({ authUser: auth.user }),
    shallowEqual
  );

  const { isLoading, entity } = useSelector((state) => {
    const s = state[CONTEXT][actionTypes.Details];
    return {
      isLoading: s.isLoading,
      entity: s.entity,
    };
  }, shallowEqual);
  const reviewFormik = useFormik({
    initialValues: {
      emy_product_id: entity.id,
      user_id: authUser.id,
      message: "",
      rating: 0,
    },
    onSubmit: (values) => {
      dispatch(ReviewActions.createEntity(values)).then((r) => {
        if (r.status === HTTP_CREATED) {
          getEntity();
        }
      });
    },
  });
  const { handleSubmit, getFieldProps } = reviewFormik;

  const [currentRoute, setCurrentRoute] = useState();
  const getEntity = () => {
    dispatch(
      actions.fetchEntity(
        slug,
        new AEMetadata(
          {},
          {},
          {},
          [
            "id",
            "title",
            "slug",
            "user_id",
            "description",
            "created_at",
            "status",
            "is_saved",
            "rating",
            "reviews_count",
            "video_url",
            "pdf_url",
            "phone",
            "phone_pro",
            "address",
            "website",

            "category",
            "function_",
            "location",
            "location.country",
            "function",
            "created_by",
            "created_by.legal_form",
            "subcategories",
            "subcategories.*.category",
            "reviews",
            "reviews.*.created_by",
            "images",
          ],
          "slug"
        ),
        actionTypes.Details
      )
    ).then(({ status }) => {
      if ([HTTP_PERMISSION_DENIED, HTTP_NOT_FOUND].includes(status)) {
        history.push(`/error/${status}`);
      }
    });
  };
  useEffect(() => {
    getEntity();
    setCurrentRoute(ROUTES.details.path.replace(":slug", slug));
  }, [slug, dispatch]);

  useEffect(() => {
    subheader.setTitle(`${entity.name} details`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity, slug]);

  useEffect(() => {
    if (entity.id) {
      reviewFormik.setFieldValue("emy_product_id", entity.id);
    }
  }, [entity.id]);

  return (
    <>
      {isLoading && (
        <Card>
          <CardBody className="text-center">
            <AESpinner />
          </CardBody>
        </Card>
      )}
      {entity.id && (
        <>
          {Number(authUser.id) === Number(entity.user_id) || authUser.roles.includes("ROLE_SUPER_ADMIN") ?
            <AERole accept={[roles.super_admin, roles.provider]}>
              <div
                className={`alert alert-custom alert-${EMY_PRODUCT_STATUSES[entity.status].className
                  } shadow-sm fade show mb-5`}
                role="alert"
              >
                <div className="alert-icon">
                  <i className="flaticon-warning" />
                </div>
                <div className="alert-text d-flex justify-content-between align-items-center">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: formatMessage({
                        id: `EMY_PRODUCT.DETAILS.${entity.status}`,
                      }),
                    }}
                  />
                  <Dropdown as={ButtonGroup}>
                    <AEButton variant={"light"} fontWeight={"bolder"}>
                      {formatMessage({ id: entity.status })}
                    </AEButton>
                    <Dropdown.Toggle split variant="light" />
                    <Dropdown.Menu className={"py-5"}>
                      {getStatusesKeys()
                        .filter((key) => key !== entity.status)
                        .map((key) => {
                          return (
                            <AERole
                              key={key}
                              accept={EMY_PRODUCT_STATUSES[key].roles}
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  dispatch(
                                    actions.updateEntity(
                                      { id: entity.id, status: key },
                                      actionTypes.Details
                                    )
                                  ).then((r) => {
                                    if (r.status === HTTP_UPDATED) {
                                      getEntity();
                                    }
                                  });
                                }}
                              >
                                <EmyProductStatus status={key} />
                              </Dropdown.Item>
                            </AERole>
                          );
                        })}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </AERole>
            :
            ''
          }

          <div className={"row"}>
            <div className="col-lg-8">
              <div className="card card-custom card-fit card-border gutter-b">
                <div className="card-header">
                  <h1 className="card-title h2 font-weight-boldest">
                    {entity.title}
                  </h1>
                </div>
                <div className="card-body pt-0">
                  <div className={"gutter-b"}>
                    <AERating value={entity.rating} />
                    <span className="text-muted font-weight-bold d-block font-size-sm pl-1">
                      {formatMessage(
                        { id: "REVIEW.COUNT" },
                        { count: entity.reviews.length }
                      )}
                    </span>
                  </div>
                  <div className={"gutter-b "}>
                    <AESlider
                      images={entity.images.map((i) => ({
                        title: i.file_name,
                        src: toAbsoluteApiUrl(
                          `${API_UPLOAD_PATH}/emy_product_images/${i.id}/${i.file_name}`
                        ),
                      }))}
                    />
                  </div>

                  <div className={"gutter-b"}>{entity.description}</div>
                  {entity.category && (
                    <div className={"gutter-b"}>
                      <span className="font-weight-bold h3">
                        {formatMessage({ id: "CATEGORY" })}
                      </span>
                      <div className="separator separator-solid separator-border-2 mb-3" />
                      <span className="label label-inline label-md label-primary m-1 ">
                        {entity.category[localField()]}
                      </span>
                    </div>
                  )}

                  <div className={"gutter-b"}>
                    <span className="font-weight-bold h3">
                      {formatMessage({ id: "SUBCATEGORIES" })}
                    </span>
                    <div className="separator separator-solid separator-border-2 mb-3" />
                    {entity.subcategories.map((s) => (
                      <span
                        key={s.id}
                        className="label label-inline label-md label-secondary m-1 "
                      >
                        {s[localField()]}
                      </span>
                    ))}
                  </div>

                  {entity.video_url && (
                    <div className={"gutter-b"}>
                      <span className="font-weight-bold h3">
                        {formatMessage({ id: "VIDEO" })}
                      </span>
                      <div className="separator separator-solid separator-border-2 mb-3" />
                      <Embed
                        className="w-100 h-350px rounded"
                        url={forceHttps(entity.video_url)}
                      />
                    </div>
                  )}

                  {entity.pdf_url && (
                    <div className={"gutter-b"}>
                      <span className="font-weight-bold h3">
                        {formatMessage({ id: "PDF" })}
                      </span>
                      <div className="separator separator-solid separator-border-2 mb-3" />
                      <iframe
                        className="w-100 h-350px rounded"
                        src={forceHttps(entity.pdf_url)}
                        title="PDF"
                      />
                    </div>
                  )}

                  <div className={"d-flex align-items-center"}>
                    <a
                      href="#block_reviews"
                      className="btn btn-hover-text-primary btn-hover-icon-primary btn-sm btn-text-dark-50 bg-hover-light-primary font-weight-bolder font-size-sm p-2"
                    >
                      <AESVG
                        path={"/Communication/Group-chat.svg"}
                        variant={"primary"}
                        className={"pr-1"}
                      />
                      {entity.reviews.length}
                    </a>
                    {/*todo saved*/}
                    <a
                      href="#"
                      className={`btn btn-sm btn-text-dark-50 ${entity.is_saved ? "text-danger" : ""
                        } bg-hover-light-danger btn-hover-text-danger font-weight-bolder font-size-sm p-2`}
                      onClick={(event) => {
                        event.preventDefault();
                        dispatch(
                          actions.toggleSave(entity.id, !entity.is_saved)
                        ).then((r) => {
                          if (r.status === HTTP_UPDATED) {
                            getEntity();
                          }
                        });
                      }}
                    >
                      <AESVG
                        path={"/General/Heart.svg"}
                        variant={entity.is_saved ? "danger" : "-"}
                        size={"md"}
                        className={"pr-1"}
                      />
                      {formatMessage({
                        id: entity.is_saved ? "SAVED" : "CLICK_TO_SAVE",
                      })}
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="card card-custom card-fit card-border gutter-b"
                id="block_reviews"
              >
                <div className="card-header">
                  <div className="card-title">
                    <span className="font-weight-boldest h3">
                      {formatMessage({ id: "REVIEWS" })}
                    </span>
                  </div>
                  {authUser.id !== entity.user_id && (
                    <div className="card-toolbar">
                      <AEButton
                        variant={"light"}
                        fontWeight={"bolder"}
                        size={"sm"}
                        onClick={handleSubmit}
                      >
                        {formatMessage({ id: "SEND" })}
                        <AESVG
                          path={"/Communication/Send.svg"}
                          variant={"primary"}
                        />
                      </AEButton>
                    </div>
                  )}
                </div>
                <div className="card-body pt-0">
                  {authUser.id !== entity.user_id && (
                    <>
                      <AERater
                        field={getFieldProps("rating")}
                        form={reviewFormik}
                        borderless
                        muliple
                        withFeedbackLabel={false}
                        validation={false}
                        name={"rating"}
                        label={"RATING"}
                        placeholder={formatMessage({ id: "MESSAGE" })}
                      />
                      <AEInput
                        type={"textarea"}
                        className="form-control-solid font-weight-bolder"
                        rows={4}
                        field={getFieldProps("message")}
                        form={reviewFormik}
                        borderless
                        muliple
                        withFeedbackLabel={false}
                        validation={false}
                        name={"message"}
                        label={"MESSAGE"}
                        placeholder={formatMessage({
                          id: "COMMENT.PLACEHOLDER",
                        })}
                      />
                      <div className="separator separator-solid mt-9 mb-4" />
                    </>
                  )}
                  <div
                    className="card-scroll"
                    style={{ maxHeight: 358, minHeight: 250 }}
                  >
                    <EditableFeedWrapper
                      ReviewActions={ReviewActions}
                      reviews={entity.reviews}
                      getEntity={getEntity}
                      authUser={authUser}
                      idField="emy_product_id"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={"col-lg-4"}>
              <div className="card card-custom gutter-b">
                <div className="card-body pt-4">
                  <UserEntityCard entity={entity.created_by} size={"sm"} />
                </div>
              </div>

              <div className="card card-custom gutter-b">
                <div className="card-body d-flex p-0 card-rounded">
                  <div
                    className="flex-grow-1 p-10 card-rounded flex-grow-1 bgi-no-repeat"
                    style={
                      {
                        // backgroundPosition: 'calc(100% + 0.5rem) bottom',
                        // backgroundSize: 'auto 75%',
                        // backgroundImage: `url(${toAbsoluteUrl('/media/svg/illustrations/copy.svg')})`
                      }
                    }
                  >
                    {/*<h4 className="mt-2 font-weight-bolder gutter-b">TODO</h4>*/}
                    {[
                      {
                        id: "ADDRESS",
                        svg: "/Map/Marker1.svg",
                        value: [
                          entity.address,
                          entity.location[localField()],
                          entity.location.country[localField()],
                        ].join(" - "),
                      },
                      {
                        id: "WEBSITE",
                        svg: "/Communication/Flag.svg",
                        value: <AEUrl value={entity.website} />,
                      },
                      {
                        id: "PHONE",
                        svg: "/Communication/Call.svg",
                        value: <AEPhone value={entity.phone} />,
                      },
                      {
                        id: "PHONE_PRO",
                        svg: "/Communication/Call.svg",
                        value: <AEPhone value={entity.phone_pro} />,
                      },
                      {
                        id: "FUNCTION",
                        svg: "/Code/Info-circle.svg",
                        value: entity.function
                          ? entity.function[localField()]
                          : "",
                      },
                    ].map((op) => (
                      <div key={op.id} className="d-flex my-2">
                        <AESVG
                          size={"md"}
                          className={"flex-shrink-0 mr-3"}
                          path={op.svg}
                        />
                        <span className="">
                          {op.value}
                          <span className={"text-muted ml-2"}>
                            {formatMessage({ id: op.id })}
                          </span>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="card card-custom bgi-no-repeat card-stretch gutter-b h-auto">
                <div className="card-body my-4">
                  <AEQRCode pathname={currentRoute} />
                </div>
              </div>

              <div className="card card-custom gutter-b card-stretch h-auto">
                <div className="card-body text-center pt-4">
                  <div className="h3 my-2 font-weight-bold">
                    {formatMessage({ id: "SHARE" })}
                  </div>
                  <AEShareButtons
                    pathname={currentRoute}
                    facebook
                    twitter
                    linkedin
                  />
                </div>
              </div>
              <AEReport />
            </div>
          </div>
        </>
      )}
    </>
  );
}
